import { IntlFormatters } from "react-intl";
import { TStage } from "./interfaces";
import messages from "./messages";

export const stages = (fm: IntlFormatters["formatMessage"]): [TStage, string][] => [
    ["youtube-video", fm(messages.youtubeVideo)],
    ["scores", fm(messages.scores)],
    ["scores-sync", fm(messages.scoresSync)],
];

export const isAvailableStage = (latest: TStage, stage: TStage, formatMessage: IntlFormatters["formatMessage"]) => {
    let stageIndex = stages(formatMessage).findIndex(s => s[0] === stage);
    let latestIndex = stages(formatMessage).findIndex(s => s[0] === latest);
    return stageIndex <= latestIndex;
};